import { useState } from 'react';
import './Events.css';

const allEvents = [
  {
    id: 1,
    title: 'Ganesh Chaturthi Grand Celebration 2025',
    date: '29 Aug 2025',
    time: '6:00 AM onwards',
    location: 'Valsad City Ground',
    category: 'Celebration',
    status: 'upcoming',
    desc: 'Grand unified celebration of Ganesh Chaturthi with 50+ mandal participating. Cultural programs, prasad distribution and more.',
    image: '🎊',
  },
  {
    id: 2,
    title: 'Blood Donation Camp',
    date: '15 Jul 2025',
    time: '9:00 AM – 5:00 PM',
    location: 'Town Hall, Valsad',
    category: 'Health',
    status: 'upcoming',
    desc: 'Annual blood donation drive in collaboration with Civil Hospital, Valsad. All healthy adults are welcome to donate.',
    image: '🩸',
  },
  {
    id: 3,
    title: 'Mandal Coordination Meeting',
    date: '05 Aug 2025',
    time: '4:00 PM – 7:00 PM',
    location: 'Community Centre, Valsad',
    category: 'Meeting',
    status: 'upcoming',
    desc: 'Quarterly coordination meeting for all registered mandal representatives to plan Ganesh Chaturthi activities.',
    image: '🤝',
  },
  {
    id: 4,
    title: 'Tree Plantation Drive',
    date: '05 Jun 2025',
    time: '7:00 AM – 11:00 AM',
    location: 'Tithal Beach, Valsad',
    category: 'Environment',
    status: 'past',
    desc: '500 saplings planted along Tithal Beach in collaboration with local mandal and forest department.',
    image: '🌳',
  },
  {
    id: 5,
    title: 'Free Medical Camp',
    date: '12 Apr 2025',
    time: '9:00 AM – 2:00 PM',
    location: 'Pardi, Valsad',
    category: 'Health',
    status: 'past',
    desc: 'Free health check-up camp serving 300+ residents. Eye check-up, diabetes screening and general consultation provided.',
    image: '🏥',
  },
  {
    id: 6,
    title: 'Cleanliness Drive — Valsad City',
    date: '22 Mar 2025',
    time: '6:30 AM – 9:00 AM',
    location: 'Various locations, Valsad City',
    category: 'Environment',
    status: 'past',
    desc: 'Swachhata Abhiyan with 200+ volunteers from 15 mandal cleaning public spaces across Valsad city.',
    image: '🧹',
  },
  {
    id: 7,
    title: 'Annadanam — Free Food Distribution',
    date: '10 Sep 2024',
    time: '11:00 AM – 3:00 PM',
    location: 'Ganesh Ground, Bulsar',
    category: 'Welfare',
    status: 'past',
    desc: 'Free meals distributed to 500 families during Ganesh Utsav in partnership with 8 Valsad mandal.',
    image: '🍱',
  },
];

const categories = ['All', 'Celebration', 'Health', 'Environment', 'Meeting', 'Welfare'];

export default function Events() {
  const [tab, setTab] = useState('upcoming');
  const [category, setCategory] = useState('All');

  const filtered = allEvents.filter((e) => {
    const matchTab = e.status === tab;
    const matchCat = category === 'All' || e.category === category;
    return matchTab && matchCat;
  });

  return (
    <div className="events-page">
      <div className="page-hero">
        <div className="container">
          <div className="badge">Community</div>
          <h1>Events & Social Activities</h1>
          <p>Celebrations, health camps, environmental drives and community welfare — Aarambh brings Valsad together.</p>
        </div>
      </div>

      <section>
        <div className="container">
          {/* Tabs */}
          <div className="events-tabs">
            <button className={`tab-btn${tab === 'upcoming' ? ' active' : ''}`} onClick={() => setTab('upcoming')}>
              🗓 Upcoming Events
            </button>
            <button className={`tab-btn${tab === 'past' ? ' active' : ''}`} onClick={() => setTab('past')}>
              📅 Past Events
            </button>
          </div>

          {/* Category Filter */}
          <div className="category-filter">
            {categories.map((c) => (
              <button
                key={c}
                className={`cat-btn${category === c ? ' active' : ''}`}
                onClick={() => setCategory(c)}
              >
                {c}
              </button>
            ))}
          </div>

          {/* Events Grid */}
          <div className="events-grid">
            {filtered.map((ev) => (
              <div key={ev.id} className="event-card card">
                <div className="event-card-top">
                  <div className="event-emoji">{ev.image}</div>
                  <span className={`event-status-badge ${ev.status}`}>
                    {ev.status === 'upcoming' ? '🟢 Upcoming' : '✅ Completed'}
                  </span>
                </div>
                <div className="event-cat-tag">{ev.category}</div>
                <h3>{ev.title}</h3>
                <p className="event-desc">{ev.desc}</p>
                <div className="event-details">
                  <div className="event-detail">📅 {ev.date}</div>
                  <div className="event-detail">⏰ {ev.time}</div>
                  <div className="event-detail">📍 {ev.location}</div>
                </div>
                {ev.status === 'upcoming' && (
                  <button className="btn-primary" style={{ width: '100%', marginTop: '16px' }}>
                    Participate / Volunteer
                  </button>
                )}
              </div>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="no-results">
              <div style={{ fontSize: '3rem' }}>📭</div>
              <h3>No events found</h3>
              <p>Check back soon or try a different category.</p>
            </div>
          )}
        </div>
      </section>

      {/* Propose Activity */}
      <section className="propose-section">
        <div className="container propose-inner">
          <div className="propose-text">
            <div className="badge">Get Involved</div>
            <h2>Want to Organise a Social Activity?</h2>
            <p>If your mandal wants to host a blood donation camp, cleanliness drive or any community welfare activity, reach out and we will support you with coordination, volunteers and resources.</p>
          </div>
          <a href="/contact" className="btn-primary" style={{ flexShrink: 0 }}>Propose an Activity</a>
        </div>
      </section>
    </div>
  );
}
